import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Standards from "./sections/Standards";
import Commitment from "./sections/Commitment";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Story />
      <Standards />
      <Commitment />
      <Contact />
      <Footer />
    </div>;
}